module.exports = __webpack_public_path__ + "static/media/contact.9adbe36e.svg";